// NOTE: Muss immer sofort geladen werden, da auf Hotelseiten sonst die Bewertungs iFrames nicht funktionieren und dort zusätzlich eingebunden werden müssten.
//const elemHotelReviewDetails = document.querySelectorAll('.wdgt-review-details');
//window.fireOnVisible(elemHotelReviewDetails, function () {
import('./assets/js/01_hotel_review_details.ts');
//});
